import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'sera-search-page-layout',
    templateUrl: './search-page-layout.component.html',
    styleUrls: ['./search-page-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SearchPageLayoutComponent {
    @Input() titleIcon: string = 'search';
    @Input() titleIconSize: 'sm' | 'md' | 'lg' = 'lg';
}
